<template>
  <div class="kt-portlet">
    <div class="kt-portlet__body kt-portlet__body--fit">
      <div class="kt-grid kt-wizard-v1 kt-wizard-v1--white">
        <div class="kt-grid__item">
          <div class="kt-wizard-v1__nav">
            <div class="kt-wizard-v1__nav-items kt-wizard-v1__nav-items--clickable">
              <div
                class="kt-wizard-v1__nav-item"
                @click.prevent="step('step-one')"
                data-ktwizard-type="step"
                :data-ktwizard-state="[ currentPage.includes('step-one') || currentPage.includes('step-two') || currentPage.includes('step-three') || currentPage.includes('step-four') || currentPage.includes('step-five') ? 'current' : '' ]"
              >
                <div class="kt-wizard-v1__nav-body flex-row align-items-center">
                  <div class="kt-wizard-v1__nav-icon pr-2">
                    <i class="flaticon-upload"></i>
                  </div>
                  <div class="kt-wizard-v1__nav-label">1. Upload files</div>
                </div>
              </div>
              <div
                class="kt-wizard-v1__nav-item"
                @click.prevent="step('step-two')"
                data-ktwizard-type="step"
                :data-ktwizard-state="[ currentPage.includes('step-two') || currentPage.includes('step-three') || currentPage.includes('step-four') || currentPage.includes('step-five') ? 'current' : '' ]"
              >
              <div class="kt-wizard-v1__nav-body flex-row align-items-center">
                  <div class="kt-wizard-v1__nav-icon pr-2">
                    <i class="flaticon2-list"></i>
                  </div>
                  <div class="kt-wizard-v1__nav-label">2. Image complexity</div>
                </div>
              </div>
              <div
                class="kt-wizard-v1__nav-item"
                @click.prevent="step('step-three')"
                data-ktwizard-type="step"
                :data-ktwizard-state="[ currentPage.includes('step-three') || currentPage.includes('step-four') || currentPage.includes('step-five') ? 'current' : '' ]"
              >
              <div class="kt-wizard-v1__nav-body align-items-center">
                  <div class="kt-wizard-v1__nav-icon pr-2">
                    <i class="flaticon2-layers"></i>
                  </div>
                  <div class="kt-wizard-v1__nav-label">3. Add-ons service</div>
                </div>
              </div>
              <div
                class="kt-wizard-v1__nav-item"
                @click.prevent="step('step-four')"
                data-ktwizard-type="step"
                :data-ktwizard-state="[ currentPage.includes('step-four') ? 'current' : '' ]"
              >
              <div class="kt-wizard-v1__nav-body align-items-center">
                  <div class="kt-wizard-v1__nav-icon pr-2">
                    <i class="flaticon2-shopping-cart"></i>
                  </div>
                  <div class="kt-wizard-v1__nav-label">4. Time and submit</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  mounted() {
    window.onbeforeunload = function() {
      return "Do you really want to leave our brilliant application?";
    };
  },
  computed: {
    ...mapGetters({
      service: 'service/service',
    }),
    currentPage() {
      return this.$route.path;
    }
  },
  methods: {
    step(routeName) {
      let arrRoute = ['step-one', 'step-two', 'step-three', 'step-four'];

      if (arrRoute.indexOf(routeName) >= arrRoute.indexOf(this.$route.name)) {
        return;
      }

      this.$router.push({
        name: routeName,
        params: { slug: this.service.slug },
        query: { ...this.$route.query },
      });
    }
  }
};
</script>

<style scoped>
.kt-wizard-v1 {
  flex-direction: column;
}
.kt-wizard-v1 .kt-wizard-v1__nav {
  border-bottom: 1px solid #eeeef4;
}
.kt-wizard-v1 .kt-wizard-v1__nav .kt-wizard-v1__nav-items {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  margin: 0 auto;
}
.kt-wizard-v1
  .kt-wizard-v1__nav
  .kt-wizard-v1__nav-items
  .kt-wizard-v1__nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  flex: 1;
}
.kt-wizard-v1
  .kt-wizard-v1__nav
  .kt-wizard-v1__nav-items
  .kt-wizard-v1__nav-item:last-child:after {
  content: none;
}
.kt-wizard-v1
.kt-wizard-v1__nav
.kt-wizard-v1__nav-items
.kt-wizard-v1__nav-item
.kt-wizard-v1__nav-body {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: .48rem;
  text-align: center;
}
.kt-wizard-v1
  .kt-wizard-v1__nav
  .kt-wizard-v1__nav-items
  .kt-wizard-v1__nav-item
  .kt-wizard-v1__nav-body
.kt-wizard-v1__nav-icon {
  font-size: 1.8rem;
  color: #a2a5b9;
}
.kt-wizard-v1
  .kt-wizard-v1__nav
  .kt-wizard-v1__nav-items
  .kt-wizard-v1__nav-item
  .kt-wizard-v1__nav-body
  .kt-wizard-v1__nav-icon
  g
  [fill] {
  transition: fill 0.3s ease;
  fill: #a2a5b9;
}
.kt-wizard-v1
  .kt-wizard-v1__nav
  .kt-wizard-v1__nav-items
  .kt-wizard-v1__nav-item
  .kt-wizard-v1__nav-body
  .kt-wizard-v1__nav-icon:hover
  g
  [fill] {
  transition: fill 0.3s ease;
}
.kt-wizard-v1
  .kt-wizard-v1__nav
  .kt-wizard-v1__nav-items
  .kt-wizard-v1__nav-item
  .kt-wizard-v1__nav-body
  .kt-wizard-v1__nav-label {
  font-size: 1.1rem;
  font-weight: 500;
  color: #74788d;
}
.kt-wizard-v1
  .kt-wizard-v1__nav
  .kt-wizard-v1__nav-items
  .kt-wizard-v1__nav-item[data-ktwizard-state='done']:after,
.kt-wizard-v1
  .kt-wizard-v1__nav
  .kt-wizard-v1__nav-items
  .kt-wizard-v1__nav-item[data-ktwizard-state='current']:after {
  color: #5d78ff;
}
.kt-wizard-v1
  .kt-wizard-v1__nav
  .kt-wizard-v1__nav-items
  .kt-wizard-v1__nav-item[data-ktwizard-state='done']
  .kt-wizard-v1__nav-body
  .kt-wizard-v1__nav-icon,
.kt-wizard-v1
  .kt-wizard-v1__nav
  .kt-wizard-v1__nav-items
  .kt-wizard-v1__nav-item[data-ktwizard-state='current']
  .kt-wizard-v1__nav-body
  .kt-wizard-v1__nav-icon {
  color: #5d78ff;
}
.kt-wizard-v1
  .kt-wizard-v1__nav
  .kt-wizard-v1__nav-items
  .kt-wizard-v1__nav-item[data-ktwizard-state='done']
  .kt-wizard-v1__nav-body
  .kt-wizard-v1__nav-icon
  g
  [fill],
.kt-wizard-v1
  .kt-wizard-v1__nav
  .kt-wizard-v1__nav-items
  .kt-wizard-v1__nav-item[data-ktwizard-state='current']
  .kt-wizard-v1__nav-body
  .kt-wizard-v1__nav-icon
  g
  [fill] {
  transition: fill 0.3s ease;
  fill: #5d78ff;
}
.kt-wizard-v1
  .kt-wizard-v1__nav
  .kt-wizard-v1__nav-items
  .kt-wizard-v1__nav-item[data-ktwizard-state='done']
  .kt-wizard-v1__nav-body
  .kt-wizard-v1__nav-icon:hover
  g
  [fill],
.kt-wizard-v1
  .kt-wizard-v1__nav
  .kt-wizard-v1__nav-items
  .kt-wizard-v1__nav-item[data-ktwizard-state='current']
  .kt-wizard-v1__nav-body
  .kt-wizard-v1__nav-icon:hover
  g
  [fill] {
  transition: fill 0.3s ease;
}
.kt-wizard-v1
  .kt-wizard-v1__nav
  .kt-wizard-v1__nav-items
  .kt-wizard-v1__nav-item[data-ktwizard-state='done']
  .kt-wizard-v1__nav-body
  .kt-wizard-v1__nav-label,
.kt-wizard-v1
  .kt-wizard-v1__nav
  .kt-wizard-v1__nav-items
  .kt-wizard-v1__nav-item[data-ktwizard-state='current']
  .kt-wizard-v1__nav-body
  .kt-wizard-v1__nav-label {
  color: #5d78ff;
}
.kt-wizard-v1
  .kt-wizard-v1__nav
  .kt-wizard-v1__nav-items.kt-wizard-v1__nav-items--clickable
  .kt-wizard-v1__nav-item {
  cursor: pointer;
}
@media (max-width: 1399px) {
  .kt-wizard-v1 .kt-wizard-v1__nav .kt-wizard-v1__nav-items {
    width: 100%;
  }
}
@media (max-width: 768px) {
  .kt-wizard-v1 .kt-wizard-v1__nav .kt-wizard-v1__nav-items {
    flex-direction: column;
    align-items: flex-start;
    padding: 2rem 0;
  }
  .kt-wizard-v1
    .kt-wizard-v1__nav
    .kt-wizard-v1__nav-items
    .kt-wizard-v1__nav-item {
    flex: 0 0 100%;
    position: relative;
    width: 100%;
  }
  .kt-wizard-v1
    .kt-wizard-v1__nav
    .kt-wizard-v1__nav-items
    .kt-wizard-v1__nav-item:after {
    position: absolute;
    right: 2rem;
  }
  .kt-wizard-v1
    .kt-wizard-v1__nav
    .kt-wizard-v1__nav-items
    .kt-wizard-v1__nav-item:last-child:after {
    content: '\f105';
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
    font-size: 2rem;
    color: #a2a5b9;
  }
  .kt-wizard-v1
    .kt-wizard-v1__nav
    .kt-wizard-v1__nav-items
    .kt-wizard-v1__nav-item
    .kt-wizard-v1__nav-body {
    flex-direction: row;
    justify-content: flex-start;
    flex: 0 0 100%;
    padding: 0.5rem 2rem;
  }
  .kt-wizard-v1
    .kt-wizard-v1__nav
    .kt-wizard-v1__nav-items
    .kt-wizard-v1__nav-item
    .kt-wizard-v1__nav-body
    .kt-wizard-v1__nav-icon {
    font-size: 1.5rem;
    margin-right: 1rem;
    margin-bottom: 0;
  }
}
.kt-wizard-v1 .kt-wizard-v1__wrapper {
  display: flex;
  justify-content: center;
  background-color: #f9fafc;
}
.kt-wizard-v1 .kt-wizard-v1__wrapper .kt-form {
  width: 60%;
  padding: 4rem 0 5rem;
}
.kt-wizard-v1 .kt-wizard-v1__wrapper .kt-form .kt-wizard-v1__content {
  padding-bottom: 2rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid #eeeef4;
}
.kt-wizard-v1
  .kt-wizard-v1__wrapper
  .kt-form
  .kt-wizard-v1__content
  .kt-wizard-v1__form {
  margin-top: 3rem;
}
.kt-wizard-v1
  .kt-wizard-v1__wrapper
  .kt-form
  .kt-wizard-v1__content
  .kt-wizard-v1__review
  .kt-wizard-v1__review-item {
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid #eeeef4;
}
.kt-wizard-v1
  .kt-wizard-v1__wrapper
  .kt-form
  .kt-wizard-v1__content
  .kt-wizard-v1__review
  .kt-wizard-v1__review-item
  .kt-wizard-v1__review-title {
  font-weight: 600;
  font-size: 1.1rem;
  margin-bottom: 0.7rem;
}
.kt-wizard-v1
  .kt-wizard-v1__wrapper
  .kt-form
  .kt-wizard-v1__content
  .kt-wizard-v1__review
  .kt-wizard-v1__review-item
  .kt-wizard-v1__review-content {
  line-height: 1.8rem;
}
.kt-wizard-v1
  .kt-wizard-v1__wrapper
  .kt-form
  .kt-wizard-v1__content
  .kt-wizard-v1__review
  .kt-wizard-v1__review-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.kt-wizard-v1 .kt-wizard-v1__wrapper .kt-form .kt-form__actions {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
@media (max-width: 576px) {
  .kt-wizard-v1 .kt-wizard-v1__wrapper .kt-form .kt-form__actions {
    flex-wrap: wrap;
    justify-content: center;
  }
}
@media (max-width: 576px) {
  .kt-wizard-v1 .kt-wizard-v1__wrapper .kt-form .kt-form__actions .btn {
    margin: 0 0.5rem 1rem;
  }
}
.kt-wizard-v1
  .kt-wizard-v1__wrapper
  .kt-form
  .kt-form__actions
  [data-ktwizard-type='action-prev'] {
  margin-right: auto;
}
@media (max-width: 576px) {
  .kt-wizard-v1
    .kt-wizard-v1__wrapper
    .kt-form
    .kt-form__actions
    [data-ktwizard-type='action-prev'] {
    margin-right: 0.5rem;
  }
}
.kt-wizard-v1
  .kt-wizard-v1__wrapper
  .kt-form
  .kt-form__actions
  [data-ktwizard-type='action-next'] {
  margin: auto 0 auto auto;
}
@media (max-width: 576px) {
  .kt-wizard-v1
    .kt-wizard-v1__wrapper
    .kt-form
    .kt-form__actions
    [data-ktwizard-type='action-next'] {
    margin: 0 0 1rem;
  }
}
@media (max-width: 768px) {
  .kt-wizard-v1 .kt-wizard-v1__wrapper {
    padding: 2rem;
  }
  .kt-wizard-v1 .kt-wizard-v1__wrapper .kt-form {
    width: 100%;
    padding: 2rem 1rem 4rem;
  }
}
.kt-wizard-v1.kt-wizard-v1--white .kt-wizard-v1__wrapper {
  background-color: #ffffff;
}
.kt-wizard-v1 [data-ktwizard-type='step-info'] {
  display: none;
}
.kt-wizard-v1 [data-ktwizard-type='step-info'][data-ktwizard-state='current'] {
  display: block;
}
.kt-wizard-v1 [data-ktwizard-type='step-content'] {
  display: none;
}
.kt-wizard-v1
  [data-ktwizard-type='step-content'][data-ktwizard-state='current'] {
  display: block;
}
.kt-wizard-v1 [data-ktwizard-type='action-prev'] {
  display: none;
}
.kt-wizard-v1 [data-ktwizard-type='action-next'] {
  display: inline-block;
}
.kt-wizard-v1 [data-ktwizard-type='action-submit'] {
  display: none;
}
.kt-wizard-v1[data-ktwizard-state='first'] [data-ktwizard-type='action-prev'] {
  display: none;
}
.kt-wizard-v1[data-ktwizard-state='first'] [data-ktwizard-type='action-next'] {
  display: inline-block;
}
.kt-wizard-v1[data-ktwizard-state='first']
  [data-ktwizard-type='action-submit'] {
  display: none;
}
.kt-wizard-v1[data-ktwizard-state='between']
  [data-ktwizard-type='action-prev'] {
  display: inline-block;
}
.kt-wizard-v1[data-ktwizard-state='between']
  [data-ktwizard-type='action-next'] {
  display: inline-block;
}
.kt-wizard-v1[data-ktwizard-state='between']
  [data-ktwizard-type='action-submit'] {
  display: none;
}
.kt-wizard-v1[data-ktwizard-state='last'] [data-ktwizard-type='action-prev'] {
  display: inline-block;
}
.kt-wizard-v1[data-ktwizard-state='last'] [data-ktwizard-type='action-next'] {
  display: none;
}
.kt-wizard-v1[data-ktwizard-state='last'] [data-ktwizard-type='action-submit'] {
  display: inline-block;
}
.kt-wizard-v1__nav-label {
  font-size: 0.9rem !important;
}
</style>
